export default __webpack_public_path__ + "static/media/icon_delete.552f7ce3.svg";